import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorOrderSearch = () => {
  const orderSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-order/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        } else {
          callback(null)
        }
      }
      loading(false)
    })
  }, [])

  return { orderSearch }
}

export default InteractorOrderSearch
